import { BaseService, type ResponseMessage, type SearchRequest } from "@kiddocare-platform/portal-common/base";
import type { Instance } from "@kiddocare-platform/portal-common/healthcare";
import type { Order } from "@kiddocare-platform/portal-common/healthcare";


export class HealthcareExecutionService extends BaseService {

  public async Search(query: SearchRequest): Promise<ResponseMessage<Array<Instance>>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/execution/instances/search`, query);
      return response.data;
    } catch (error: any) {
      this.log.error("Search", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async Create(data: {
    reasonRequest: string;
    detailRequest?: string;
    idAccountPatient: bigint;
    idAccountPediatrician: bigint;
  }): Promise<ResponseMessage<Instance>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/execution/instances/create`, data);
      return response.data;
    } catch (error: any) {
      this.log.error("Create", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async GetByTicket(ticket: string): Promise<ResponseMessage<Instance>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/execution/instances/getByTicket/${ticket}`);
      return response.data;
    } catch (error: any) {
      this.log.error("GetByTicket", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async Delete(data: { ticket: string }): Promise<unknown> {
    try {
      const response = await this.AxiosInstance.put(`/parent/execution/instances/delete`, data);
      return response.data;
    } catch (error: any) {
      this.log.error("Delete", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async Renew(data: { ticket: string }): Promise<ResponseMessage<{ instance?: Instance, orders?: Array<Order> }>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/execution/instances/renew`, data);
      return response.data;
    } catch (error: any) {
      this.log.error("Renew", error.stack, JSON.stringify(error));
      throw error;
    }
  }

}
